var map = {
	"./Example-Videos-1.png": 7182,
	"./Example-Videos-2.jpg": 437,
	"./Example-Videos-3.jpg": 2824,
	"./Welcome-to-Snapshot.jpg": 2716,
	"./btns.png": 2968,
	"./check.png": 2323,
	"./discuss-desgin.png": 6270,
	"./header-logo.png": 2646,
	"./land-ph.png": 2259,
	"./landing-header.png": 4002,
	"./left-side.png": 5358,
	"./right-side.png": 8177,
	"./signals.png": 1292,
	"./submit-btn.png": 8556,
	"./testimonial/Jaime Rice Headshot.jpeg": 5895,
	"./testimonial/Shawn Sullivan Headshot.jpeg": 8069,
	"./testimonial/Stephanie Spalding Headshot.jpeg": 8519,
	"./top.png": 6322,
	"./video-btn-desgin.png": 5126,
	"./video-btn.png": 558,
	"./video-desgin.png": 3903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;